import { useCallback, useState } from 'react';

import { movesToFen } from '@libs/chess/movesToFen';
import { IPgnMove } from '@libs/chess/pgn';

import { ValuatorPreview, ValuatorVariant } from '..';

export function useValuatorPreview(fen?: string) {
  const [preview, setPreview] = useState<ValuatorPreview | undefined>();
  const onMoveHover = useCallback(
    (m: IPgnMove, v: ValuatorVariant) => {
      const moveSeq = v.moves.slice(0, v.moves.indexOf(m) + 1);
      setPreview(movesToFen(fen, moveSeq));
    },
    [fen],
  );

  return { preview, onMoveHover };
}
